import React from 'react';
import { Link } from 'react-router-dom';
import CursiveTool from '../components/tool/CursiveTool';
import ContentBody, { Sources } from '../components/editorial/ContentBody';
import Faq from '../components/Faq';
import { articlesFor, PILLARS } from '../data/editorial';
import { T } from '../data/i18n';

export default function PillarPage({ pillar }) {
  const posts = articlesFor(pillar.id);
  const t = { ...T.fr, all: 'Tous les styles', output: 'Votre texte stylisé' };
  return <div data-testid={`pillar-${pillar.id}`}>
    <section className="content-narrow page-hero">
      <nav aria-label="Fil d’Ariane" className="text-sm mb-5"><Link to="/fr/ecriture-cursive">Cursivefont</Link><span aria-hidden="true"> / </span>{pillar.title}</nav>
      <h1 className="hero-title">{pillar.title}</h1>
      <section aria-label="En bref"><strong>En bref</strong><p className="hero-intro">{pillar.answer}</p></section>
    </section>
    <div className="px-4" id="generateur"><CursiveTool key={pillar.id} t={t} initialStyle={pillar.initialStyle} /></div>
    <section className="content-narrow prose-site py-12">
      <ContentBody blocks={pillar.body} />
      <h2>Guides pour aller plus loin</h2>
      <ul>{posts.map(post => <li key={post.slug}><Link to={`/fr/blog/${post.slug}`}>{post.title}</Link><p>{post.excerpt}</p></li>)}</ul>
      <Sources items={pillar.sources} />
      <h2>Explorer les autres styles</h2>
      <ul>{PILLARS.filter(p => p.id !== pillar.id).map(p => <li key={p.id}><Link to={p.path}>{p.title}</Link></li>)}</ul>
    </section>
    <Faq items={pillar.faq} title="Questions fréquentes" />
  </div>;
}
